module.exports = __webpack_public_path__ + "static/media/play-store-cache-pl.f994fbc0.png";